import { apiPost } from './index';
import { ClientError } from '../../../common/framework/model/ClientError';
import { sharedState } from '../state';

export async function postClientError(errorMessage: string): Promise<void> {
    if (sharedState.authenticated) {
        const response = await apiPost('/api/error', new ClientError(errorMessage));
    }
}
